import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  importProvidersFrom,
  input,
  OnInit,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';

import { DashboardComponent } from './dashboard/dashboard.component';
import { WidgetRendererComponent } from './widget-renderer/widget-renderer.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { SideNavbarComponent } from '../../../../custom/chart-components/side-navbar/side-navbar.component';
import { ThemeService } from '@shared-lib/shared-services/theme.service';

import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatRadioModule,
    SideNavbarComponent,
    NgxEchartsModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  data: any;
  constructor(
    private keycloakService: KeycloakService,
    private router: Router,
    private titleService: Title,
    private themeService: ThemeService
  ) {
    this.init();
  }

  ngOnInit(): void {
    this.setTabAndIcon();
    this.initTheme();
  }

  /**
   * Initialize the active theme.
   * Priority: user's saved theme (localStorage) > environment default > 'default'.
   * Custom overrides (from Custom Theme tab) are layered on top automatically.
   * Dashboard JSONs may still override this via "theme" / "themeOverrides".
   */
  private initTheme(): void {
    const fallback = (environment as any).THEME_NAME || 'default';
    this.themeService.loadManifest().subscribe();
    this.themeService.initFromPersistence(fallback);
  }

  private setTabAndIcon(): void {
    if (environment.TAB_NAME) {
      this.titleService.setTitle(environment.TAB_NAME);
    }
    
    if (environment.ICON_URL) {
      let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = environment.ICON_URL;
    }
  }

  async init() {
    const loggedIn = await this.keycloakService.isLoggedIn();
    if (!loggedIn) {
      this.keycloakService.login();
    }
  }

  logout(): void {
    this.keycloakService.logout();
  }
}
